import React from "react";
import Card from "react-bootstrap/Card";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello everyone, I am <span className="purple">Mustafa Al Shamkhany </span>
            from <span className="purple"> Basrah, Iraq</span>.
            <br />
            <br />I am a graduate from the American University of Sharjah with a Bsc degree
            in Computer Science and Engineering.
            <br />
            <br />
            My passion revolves around building applications that can benefit the 
            people out there. helping people in any way I can, whether be it through 
            my profession or in any other way gives me joy in life 
            <span className="purple"> : )</span>
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
          <li className="about-activity">
              <i className="far fa-hand-point-right purple"></i> Building Smart homes appliances
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right purple"></i> Competetive Gaming
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right purple"></i> Custom PC builds
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right purple"></i> Travelling
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Mustafa</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
